import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
declare var $: any;
@Component({
  selector: 'app-input-dialog',
  templateUrl: './input-dialog.component.html',
  styleUrls: ['./input-dialog.component.css']
})
export class InputDialogComponent {


  @ViewChild("passwordfocus", { static: false }) passwordfocus: ElementRef;
  type: boolean;
  constructor(
    public dialogRef: MatDialogRef<InputDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    $('.cdk-overlay-dark-backdrop').addClass('mod')
    $('.cdk-overlay-dark-backdrop.mod').css("opacity", "0.7");
    if (data.inputType && data.inputType != undefined && data.inputType == 'pass') {
      this.type = true;
      setTimeout(() => {
        this.passwordfocus.nativeElement.focus();
      }, 100);
    }
    else
      this.type = false;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  Ispswdempty() {
    if (this.type) {
      return this.data.inputValue.trim().length == 0;

    }
    else {
      return false;

    }

  }

  onEnterClick(event: any) {
    const pwd = event.target.value;
    if (event.keyCode === 13) {
      this.dialogRef.close(pwd);
    }
  }
}
export interface DialogData {
  inputValue: string;
  headerText: string;
  inputType: string;
}